import * as React from "react";

export const DashboardContext = React.createContext({
    isEditing: false,
    setIsEditing: (val) => {},
    isConfiguringWidget: false,
    setIsConfiguringWidget: (val) => {},
});

export function useDashboard() {
    return React.useContext(DashboardContext);
}

export function DashboardProvider({ children }) {
    const [isEditing, setIsEditing] = React.useState(false);
    const [isConfiguringWidget, setIsConfiguringWidget] = React.useState(false);

    let value = {
        isEditing,
        setIsEditing,
        isConfiguringWidget,
        setIsConfiguringWidget,
    };

    return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
}
